// extracted by mini-css-extract-plugin
module.exports = {"stat":"stat-evolution_stat__ZjctK","positive":"stat-evolution_positive__rM9pT","icon":"stat-evolution_icon__2Eplf"};